import { Box } from "@mui/material";
import ItemsContent from "../../components/entityGrid/ItemsContent";
import Navbar from "../../components/Navbar";
import { useEffect, useState } from "react";
import { useApp } from "../../hooks/useApp";
import { useAuth } from "../../hooks/useAuth";
import { canUserViewAsset } from "../../Utils/assetVisibility";

export default function Assets() {
  const { mergedAssets } = useApp();
  const { user } = useAuth();
  const [loader, setLoader] = useState(true);
  const [vtecAssets, setVtecAssets] = useState([]);

  useEffect(() => {
    if (!mergedAssets || !user) {
      setLoader(false);
      return;
    }

    const updatedAssets = mergedAssets.filter(
      (asset) =>
        asset.Type &&
        ["app", "beacon", "video"].includes(asset.Type) &&
        canUserViewAsset(asset, user)
    );
    setVtecAssets(updatedAssets);
    setLoader(false);
  }, [mergedAssets, user]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <Navbar />
      <ItemsContent assets={vtecAssets} loader={loader} url={"/assets"} />
    </Box>
  );
}
